import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { NoticePanel } from '@/components/admin/notice/NoticePanel';
import { PaymentEventPanel } from '@/components/admin/payment-event/PaymentEventPanel';
import { SupabaseLoginGate } from '@/master-data/SupabaseLoginGate';

const PAYMENT_TAB = 'payment-event';

export default function NoticeManagementPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === PAYMENT_TAB ? PAYMENT_TAB : 'notice';

  return (
    <Tabs
      value={tab}
      onValueChange={(v) => setParams(v === PAYMENT_TAB ? { tab: v } : {}, { replace: true })}
    >
      <TabsList className="mx-6 mt-6">
        <TabsTrigger value="notice">공지</TabsTrigger>
        <TabsTrigger value={PAYMENT_TAB}>결제 이벤트</TabsTrigger>
      </TabsList>
      {/* forceMount + CSS 숨김 — 공지 탭은 언마운트하지 않는다. 언마운트하면 미저장
          편집분·flavor·channel 선택이 조용히 사라지고 복귀 시 R2 재조회로 덮인다.
          (forceMount 를 주면 Radix 가 hidden 속성을 걸지 않으므로 직접 숨긴다.) */}
      <TabsContent value="notice" forceMount className={tab === 'notice' ? undefined : 'hidden'}>
        <NoticePanel />
      </TabsContent>
      {/* 반대로 결제 이벤트 탭에는 forceMount 를 쓰지 않는다 — 언마운트 상태로 남아야
          SupabaseLoginGate 가 마운트되지 않아서, 공지 탭만 쓰는 사용자에게 Supabase
          로그인을 강요하지 않는다. */}
      <TabsContent value={PAYMENT_TAB}>
        <SupabaseLoginGate>
          <PaymentEventPanel />
        </SupabaseLoginGate>
      </TabsContent>
    </Tabs>
  );
}
